module.exports = __webpack_public_path__ + "static/media/ex-big.782e15f4.png";